export const getNameInitials = (name) => {
  const splittedName = name.replace(/\s+/g, ' ').trim().split(' ');

  if (splittedName.length >= 2) {
    const firstNameFirstLetter = splittedName[0][0];
    const secondNameFirstLetter = splittedName[1][0];
    return firstNameFirstLetter + secondNameFirstLetter;
  }

  return splittedName[0][0];
};
